<template>
  <div class="container pt-5">
    <div class="row">
      <div class="col-6 col-sm-4">
        <button v-on:click="sendWords" class="btn btn-lg btn-block btn-primary">{{getText()}}</button>
      </div>
    </div>
  </div>
</template>

<script>
import {SEND_WORDS} from '@/store/action-types';
import {mapState} from 'vuex';

export default {
  name: "ActionButtons",
  computed: {
    ...mapState([
      'domainChecks',
    ])
  },
  methods: {
    sendWords () {
      this.$store.dispatch(SEND_WORDS, true);
    },
    getText() {
      return this.domainChecks.length ? 'Regenerate': 'Generate';
    }
  }
}
</script>

<style scoped lang="scss">

</style>
